export const isOptionEnabled = ({
  min,
  max,
  value1,
  value2,
}: {
  min?: number
  max?: number
  value1: string
  value2: string
}) => {
  const value = Number(`${value1}.${value2}`)
  if (min != null && value < min) {
    return false
  }
  if (max != null && value > max) {
    return false
  }
  return true
}

export const getClosestValue = ({
  options,
  isDisabled,
  index,
}: {
  options: { label: string; value: string }[]
  isDisabled?: (value: string) => boolean
  index: number
}) => {
  const closestValues = options.map((o, i) => {
    const valid = !isDisabled?.(o.value)
    if (valid) {
      return Number(index) - Number(i)
    }
    return Infinity
  })
  const closestIndex = closestValues.indexOf(Math.min(...closestValues))
  const closestValue = options[closestIndex]?.value

  return closestValue
}
